module.exports = __webpack_public_path__ + "img/to_stop_selected.fca779a8.svg";